import UserProfile from "@/domain/entities/user/UserProfile";
import { userToDomainMapper } from "@/mappers/user/userMapper";
import { useUserProfile } from "@cs_teamwaydev/mailvista-sdk_react";
import { useMemo } from "react";
import useLiveErrorNotifier from "./utils/useLiveErrorNotifier";

const useGetUserProfile = (): {
    data: UserProfile | undefined;
    isLoading: boolean;
    error: unknown;
} => {
    const { data: profile, isLoading, error } = useUserProfile();

    useLiveErrorNotifier(error, {
        titleTranslationKey: "errors.global.title",
    });

    const data = useMemo(
        () => (profile ? userToDomainMapper(profile) : undefined),
        [profile],
    );

    return { data, isLoading, error };
};

export default useGetUserProfile;
